export default "__VITE_ASSET__3aac982e__"